module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item.file) ? _c('v-dialog', {
    attrs: {
      "width": "50%",
      "max-width": "700px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('a', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.item.name))])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "center-align",
    attrs: {
      "xs6": ""
    }
  }, [_c('img', {
    staticClass: "responsive-img elevation-5",
    attrs: {
      "src": _vm.item.file.thumbs.medium
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card-text', [_c('item-summary', {
    attrs: {
      "item": _vm.item
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.item.file.files.preview,
      "target": "_blank"
    }
  }, [_vm._v("Preview File")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.item.file.files.cover,
      "target": "_blank"
    }
  }, [_vm._v("Cover File")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.item.file.files.content,
      "target": "_blank"
    }
  }, [_vm._v("Content File")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.item.file.files.original,
      "target": "_blank"
    }
  }, [_vm._v("Original File")])])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bf52afe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/detail-modal.vue
// module id = 634
// module chunks = 1